import styled from 'styled-components';

export const SelectionCellWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
